import { Flex, Separator } from '@chakra-ui/react';
import { memo } from 'react';

import ColorFilters from '@features/marketplace/navigation/ColorFilters';
import PriceFilters from '@features/marketplace/navigation/PriceFilters';

const FilterSectionContent = () => {
  return (
    <Flex flexDir="column" gap={2} w="full">
      <ColorFilters />
      <Separator borderColor="border.light" />
      <PriceFilters />
    </Flex>
  );
};

export default memo(FilterSectionContent);
